import React, { useMemo, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { sanitizeOptimizationDescription } from 'utils/sanitizeOptimizationDescription';

export default function UserTextAccordion({ userText, defaultOpen = false }) {
  const raw = typeof userText === 'string' ? userText.trim() : '';
  const [isOpen, setIsOpen] = useState(Boolean(defaultOpen));

  const safeHtml = useMemo(() => {
    if (!raw) return '';
    return sanitizeOptimizationDescription(raw, { fallbackText: '' });
  }, [raw]);

  if (!raw) return null;

  return (
    <div className="mb-4">
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        className="w-full border border-white/10 bg-transparent hover:bg-white/5 text-white/70 px-3 py-2 rounded-lg text-sm flex items-center justify-between focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
      >
        <span className="text-xs font-semibold">
          {isOpen ? 'Ocultar descripción' : 'Ver descripción completa'}
        </span>
        {isOpen ? <ChevronUp className="w-4 h-4" aria-hidden /> : <ChevronDown className="w-4 h-4" aria-hidden />}
      </button>

      {isOpen ? (
        <div className="mt-2 p-3 rounded-lg border border-white/10 bg-white/5 text-sm leading-relaxed text-white/90">
          <div dangerouslySetInnerHTML={{ __html: safeHtml }} />
        </div>
      ) : null}
    </div>
  );
}

